// extracted by mini-css-extract-plugin
export default {"form":"AlbumForm_form__5ABNG"};